import styled from "@emotion/styled"
import {
	spacingFluid2Xl,
	spacingFluidLg,
	spacingFluidMd,
	spacingFluidSm,
	spacingFluidXl,
	spacingFluidXs,
} from "@porsche-design-system/components-react/emotion"

export interface FlexProps {
	$alignItems?: "center" | "flex-start" | "flex-end"
	$direction?: "column"
	$gap?: keyof typeof mapGapToSpacingFluid
	$justifyContent?: "center" | "flex-start" | "flex-end" | "space-between"
	$wrap?: "wrap"
}

export const mapGapToSpacingFluid: Record<"xs" | "sm" | "md" | "lg" | "xl" | "2xl", string> = {
	"2xl": spacingFluid2Xl,
	lg: spacingFluidLg,
	md: spacingFluidMd,
	sm: spacingFluidSm,
	xl: spacingFluidXl,
	xs: spacingFluidXs,
}

export const Flex = styled.div<FlexProps>`
	display: flex;
	justify-content: ${({ $justifyContent }) => $justifyContent};
	align-items: ${({ $alignItems }) => $alignItems};
	flex-direction: ${({ $direction }) => $direction};
	flex-wrap: ${({ $wrap }) => $wrap};
	gap: ${({ $gap }) => $gap && mapGapToSpacingFluid[$gap]};
`
